<template>
  <router-link :to="`/axborot/yangiliklar/${item.id}`" :class="['nc', `nc--${size}`]">

    <!-- Vertical cards (large / medium): image wrap with overlaid badge -->
    <div v-if="isVertical" class="nc__img-wrap">
      <span class="nc__img-clip"><img :src="imgSrc" :alt="item.title" class="nc__img" /></span>
      <span class="yn-badge">
        <img src="@/assets/img/logos/date.png" alt="" class="yn-badge__icon" />
        {{ $fdate(item.date) }}
      </span>
      <ViewCount :count="item.views || 0" overlay />
    </div>

    <!-- Horizontal card (small): flush thumbnail -->
    <span v-else class="nc__img-sm-clip"><img :src="imgSrc" :alt="item.title" class="nc__img-sm" /></span>

    <!-- Body: always rendered -->
    <div class="nc__body">
      <component :is="isLarge ? 'h6' : 'p'" class="nc__title">{{ item.title }}</component>
      <p v-if="isLarge && item.excerpt" class="nc__excerpt">{{ item.excerpt }}</p>
      <span v-if="!isVertical" class="nc__meta">
        <span class="yn-badge">
          <img src="@/assets/img/logos/date.png" alt="" class="yn-badge__icon" />
          {{ $fdate(item.date) }}
        </span>
        <ViewCount :count="item.views || 0" class="nc__views" />
      </span>
    </div>

  </router-link>
</template>

<script>
import { resolveImage } from '@/store/api'
import ViewCount from '@/components/common/ViewCount.vue'

export default {
  name: 'NewsCard',
  components: { ViewCount },
  props: {
    item: { type: Object,  required: true },
    size: {
      type: String,
      default: 'medium',
      validator: v => ['large', 'medium', 'small'].includes(v)
    }
  },
  computed: {
    isVertical() { return this.size !== 'small' },
    isLarge()    { return this.size === 'large'  },

    imgSrc() {
      return resolveImage(this.item.image)
    }
  }
}
</script>

<style scoped>
/* Small (horizontal) card: date badge + reader count share one row. */
.nc__meta {
  display: flex;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
}
.nc__views { color: #1D5DFF; }
</style>
